import { IBoltTaskTemplate, SLAUnits } from "@bolt/core";
import { GridColumn, GridHtmlColumn } from "@ucl/library";

export const TaskTemplateGridConfig: GridColumn[] = [
  new GridColumn({
    field: "id",
    headerText: "Id",
    type: "string",
    visible: false,
    maxWidth: 400,
  }),
  new GridColumn({
    field: "taskTemplateName",
    headerText: "Template Name",
    type: "string",
    maxWidth: 400,
  }),
  new GridHtmlColumn({
    field: "taskTemplateDescription",
    headerText: "Template Description",
    type: "string",
    maxWidth: 400,
  }),
  new GridColumn({
    field: "hasMultiSteps",
    headerText: "Multi Step Workflow",
    type: "boolean",
    valueAccessor: (field, data) => {
      const val = (data as unknown as { [key: string]: string })[
        field
      ].toString();
      if (!val) return "";
      return val;
    },
    maxWidth: 400,
  }),
  new GridColumn({
    field: "stepName",
    headerText: "Step Name",
    type: "string",
    maxWidth: 400,
  }),
  new GridColumn({
    field: "sla",
    headerText: "SLA",
    type: "number",
    maxWidth: 400,
    valueAccessor: (__, data) => {
      const unit =
        (data as unknown as IBoltTaskTemplate)?.slaUnit ?? SLAUnits.Hour;
      const slaUnit = SLAUnits[unit];
      const sla = (data as unknown as IBoltTaskTemplate)?.sla ?? 1;

      return `${sla} ${slaUnit}(s)`;
    },
    allowSearching: false,
    allowFiltering: false,
  }),
  new GridColumn({
    field: "taskPriority_AsString",
    headerText: "Priority",
    type: "string",
    maxWidth: 400,
  }),
  new GridColumn({
    field: "createdBy_AsName",
    headerText: "Created By",
    type: "string",
    maxWidth: 400,
  }),
  new GridColumn({
    field: "createdAt",
    headerText: "Created Date",
    format: { format: "MM/dd/yyyy hh:mm:ss a", type: "date" },
    type: "datetime",
    maxWidth: 400,
    allowSearching: false,
    allowFiltering: false,
  }),
  new GridColumn({
    field: "updatedBy_AsName",
    headerText: "Updated By",
    type: "string",
    maxWidth: 400,
  }),
  new GridColumn({
    field: "updatedAt",
    headerText: "Updated Date",
    format: { format: "MM/dd/yyyy hh:mm:ss a", type: "date" },
    type: "datetime",
    maxWidth: 400,
    allowSearching: false,
    allowFiltering: false,
  }),
];
